import ReportByUser from './ReportByUser'
import withReportByUser from './withReportByUser'

const ConnectedReportByUser = withReportByUser(ReportByUser)

export { ConnectedReportByUser as ReportByUser }
